import { render } from "./RatingInput.vue?vue&type=template&id=28f9cb1c&scoped=true&ts=true"
import script from "./RatingInput.vue?vue&type=script&lang=ts"
export * from "./RatingInput.vue?vue&type=script&lang=ts"

import "./RatingInput.vue?vue&type=style&index=0&id=28f9cb1c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28f9cb1c"]])

export default __exports__